import { Controller } from "@hotwired/stimulus"

// Puts thousands commas in a whole-dollar text input as it is typed
// ("26957" reads "26,957"), keeping the caret after the same digit. Anything
// that is not a digit is dropped. The server strips the commas again before
// it saves (ProjectionRequestsController#document_amount_params). Number inputs cannot
// show commas, so these amounts are text inputs with a numeric keyboard.
//
// Whole dollars only: everything from a decimal point on is cut, never
// merged into the dollars ("26,957.50" stays 26,957, not 2,695,750). While
// the box has focus a typed point stays on screen, so the cents typed after
// it fall away instead of joining the dollars; leaving the box (blur) drops
// the point too.
export default class extends Controller {
  format() {
    const input = this.element
    const caretAt = input.selectionStart
    const pointAt = input.value.indexOf(".")
    const dollars = pointAt === -1 ? input.value : input.value.slice(0, pointAt)
    const keepPoint = pointAt !== -1 && document.activeElement === input
    const digitsBeforeCaret = input.value.slice(0, Math.min(caretAt, dollars.length)).replace(/\D/g, "").length
    const formatted = dollars.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (keepPoint ? "." : "")
    if (formatted === input.value) return

    input.value = formatted
    if (document.activeElement !== input) return

    let caret = 0
    let seen = 0
    while (caret < formatted.length && seen < digitsBeforeCaret) {
      if (/\d/.test(formatted[caret])) seen++
      caret++
    }
    // A caret in the cut cents lands after the point.
    if (keepPoint && caretAt > pointAt) caret = formatted.length
    input.setSelectionRange(caret, caret)
  }
}
